import { TIPO_DOCUMENTO } from "~/constants";

export const TIPO_PESQUISA = {
  NUMEROS_INTEIROS: 'numerosInteiros',
  NUMEROS_FLUTUANTES: 'numerosFlutuantes',
  TEXTO: 'texto',
  MISTO: 'misto',
}

export function ordenarPorRelevancia(dados, buscaOriginal, tipoDocumento, tipoPesquisa) {
  // Dão prioridade para um item na listagem com base nos pesos/bonus definidos em calcularScoreTexto()
  // Ex: Se assim definido: (Item exato da pesquisa > Item que inicia com a pesquisa > Item com pesquisa encontrada parcialmente no meio)

  // prioridades{} = Pesos/bonus adicionados com base na importancia que uma propriedade tem sobre outra.
  // Ex: Se assim definido, match de "Rodrigo" em NomeCliente recebe bonus maior que match de "Rodrigo" em fatVendedor.nome.

  // Desempate ocorre em ordem alfanumética com base nas propriedades: (clienteNome > fatVendedor.nome > documentoNumero)

  if (!tipoPesquisa) {
    tipoPesquisa = TIPO_PESQUISA.MISTO
  }

  if (
    tipoPesquisa === TIPO_PESQUISA.NUMEROS_FLUTUANTES ||
    tipoPesquisa === TIPO_PESQUISA.NUMEROS_INTEIROS
  ) {
    buscaOriginal = buscaOriginal.replace(/,/g, ".")
    if (buscaOriginal !== "" && !Number.isNaN(Number(buscaOriginal))) {
      buscaOriginal = String(Number(buscaOriginal));
    }
  }

  const busca = normalizar(buscaOriginal);

  let prioridades = null

  switch (tipoPesquisa) {

    case TIPO_PESQUISA.NUMEROS_INTEIROS:
        switch (tipoDocumento) {
          case TIPO_DOCUMENTO.ORCAMENTO:
            prioridades = {
              numero: 600,
              valorTotal: 100,
            }
            break;
          case TIPO_DOCUMENTO.PEDIDO:
            prioridades = {
              numero: 600,
              xPed: 300,
              xCont: 200,
              valorTotal: 100,
            }
            break;
          case TIPO_DOCUMENTO.DOCUMENTOSAIDA: 
            prioridades = {
              documentoNumero: 600,
              xPed: 300,
              xCont: 200,
              valorTotal: 100,
            }
            break;
        }
      break;

    case TIPO_PESQUISA.NUMEROS_FLUTUANTES:
        switch (tipoDocumento) {
          case TIPO_DOCUMENTO.ORCAMENTO:
            prioridades = {
              valorTotal: 100
            }
            break;
          case TIPO_DOCUMENTO.PEDIDO:
            prioridades = {
              valorTotal: 100
            }
            break;
          case TIPO_DOCUMENTO.DOCUMENTOSAIDA: 
            prioridades = {
              valorTotal: 100
            }
            break;
        }
      break;

    case TIPO_PESQUISA.TEXTO:
        switch (tipoDocumento) {
          case TIPO_DOCUMENTO.ORCAMENTO:
            prioridades = {
              clienteNome: 500,
              "fatVendedor.nome": 400,
            }
            break;
          case TIPO_DOCUMENTO.PEDIDO:
            prioridades = {
              clienteNome: 500,
              "fatVendedor.nome": 400,
            }
            break;
          case TIPO_DOCUMENTO.DOCUMENTOSAIDA: 
            prioridades = {
              clienteNome: 500,
              "fatVendedor.nome": 400,
            }
            break;
        }
      break;

    case TIPO_PESQUISA.MISTO:
        switch (tipoDocumento) {
          case TIPO_DOCUMENTO.ORCAMENTO:
            prioridades = {
              numero: 600,
              clienteNome: 500,
              "fatVendedor.nome": 400,
              valorTotal: 100
            }
            break;
          case TIPO_DOCUMENTO.PEDIDO:
            prioridades = {
              numero: 600,
              clienteNome: 500,
              "fatVendedor.nome": 400,
              xPed: 300,
              xCont: 200,
              valorTotal: 100
            }
            break;
          case TIPO_DOCUMENTO.DOCUMENTOSAIDA: 
            prioridades = {
              documentoNumero: 600,
              clienteNome: 500,
              "fatVendedor.nome": 400,
              xPed: 300,
              xCont: 200,
              valorTotal: 100
            }
            break;
        }
      break;
  }

  if (!prioridades) return dados

  let prioridades_desempate = null

  switch (tipoDocumento) {
    case TIPO_DOCUMENTO.ORCAMENTO:
      prioridades_desempate = [
        'numero',
        'clienteNome',
        'fatVendedor.nome',
        'valorTotal',
      ]
      break;
    case TIPO_DOCUMENTO.PEDIDO:
      prioridades_desempate = [
        'numero',
        'clienteNome',
        'fatVendedor.nome',
        'xPed',
        'xCont',
        'valorTotal',
      ]
      break;
    case TIPO_DOCUMENTO.DOCUMENTOSAIDA: 
      prioridades_desempate = [
        'documentoNumero',
        'clienteNome',
        'fatVendedor.nome',
        'xPed',
        'xCont',
        'valorTotal',
      ]
      break;
  }

  const dadosComScore = dados.map(item => {
    let scoreTotal = 0;

    for (const campo of Object.keys(prioridades)) {

      const rawValue = getValorPorCaminho(item, campo);
      const valor = normalizar(String(rawValue ?? ""));

      const scoreTexto = calcularScoreTexto(valor, busca);

      if (scoreTexto > 0) {
        scoreTotal += scoreTexto + prioridades[campo];
      }
    }

    return { item, score: scoreTotal };
  });


  dadosComScore.sort((a, b) => {
    if (a.score !== b.score) {
      // Ordena por score
      return b.score - a.score;
    }

    for (const campo of prioridades_desempate) {
      // Em caso de empate, desempata alfanumericamente
      // seguindo as prioridades para desempate definidas

      const valorA = getValorPorCaminho(a.item, campo);
      const valorB = getValorPorCaminho(b.item, campo);

      const resultado = compararValores(valorA, valorB);

      if (resultado !== 0) {
        return resultado;
      }
    }

    return 0;
  });

  return dadosComScore.map(d => d.item);
}


const normalizar = (str = "") =>
  str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();


const getValorPorCaminho = (obj, caminho) => {
  return caminho
    .split(".")
    .reduce((acc, chave) => acc?.[chave], obj);
};


const compararValores = (a, b) => {

  if (a == null && b == null) return 0;
  if (a == null) return -1;
  if (b == null) return 1;

  const numA = Number(a);
  const numB = Number(b);;

  if (
    a !== "" &&
    b !== "" &&
    Number.isFinite(numA) &&
    Number.isFinite(numB)
  ) {
    // Comparação numérica
    return numA - numB;
  }

  // Comparação alfanumérica
  return String(a).localeCompare(
    String(b),
    "pt-BR",
    { numeric: true, sensitivity: "base" }
  );
};


const calcularScoreTexto = (texto, busca) => {
  if (!texto || !busca) return 0;

  texto = texto.toLowerCase();
  busca = busca.toLowerCase();

  if (!texto.includes(busca)) return 0;

  if (texto === busca) {
    // Bonus valor fixo match exato da pesquisa
    return 5000;
  }

  let score = 0;

  if (texto.startsWith(busca)) {
    // Bonus inicia exatamente com a pesquisa
    score += 800;
  } else if (texto.indexOf(" " + busca) !== -1) {
    // Bonus possui exata pesquisa no meio
    score += 600;
  } else {
    // Bonus possui parcialmente pesquisa no meio
    score += 300;
  }

  const posTexto = texto.indexOf(busca);
  if (posTexto < 200) {
    // Bonus quanto mais cedo pesquisa aparecer na palavra
    // (Ex: Pesquisa: "iago" | Hiago > Santiago)
    score += 200 - posTexto;
  }

  const palavras = texto.split(" ");
  palavras.forEach((palavra, indexPalavra) => {
    const posPalavra = palavra.indexOf(busca);
    if (posPalavra !== -1) {
      // Bonus quanto mais cedo palavra aparecer na frase
      // (Ex: Pesquisa: "gomes" | João Gomes Santos > João Santos Gomes)
      score += Math.max(0, 800 - (indexPalavra * 200));

      // Bonus por aparecer na primeira palavra da frase
      if (posPalavra === 0) {
        score += 200;
      }

    }
  });

  return score;
};